import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { ImInfo } from "react-icons/im";
import './TooltipAd.scss';



const TooltipAd = ({ renderComponent }) => {
  const renderTooltip = (props) => {
    return (<Tooltip {...props} className="custom-tooltip">{renderComponent}</Tooltip>);
  };

  return (
    <>
      {/* SCREEN ONLY */}
      <div className="screen-ad-info">
        <OverlayTrigger
          placement="right"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip}
        >
          <span className="ad-info-trigger d-flex flex-column align-items-center">
            <ImInfo size={30} />
            <span className="mt-2">Ad info</span>
          </span>
        </OverlayTrigger>
      </div>

      {/* PRINT ONLY */}
      <div className="print-ad-info">
        {renderComponent}
      </div>
    </>
  );
};

export default TooltipAd;
